import { db } from '@/shared/lib/db'

export const getScreenplay = async (projectId: string, fileName: string) => {
    const screenplay = await db.screenplays
        .where('[projectId+title]')
        .equals([projectId, fileName])
        .first()
    return screenplay
}

export const getStory = async (projectId: string, fileName: string) => {
    const story = await db.stories.where('[projectId+title]').equals([projectId, fileName]).first()
    return story
}

export const getScreenplayV2S = async (projectId: string) => {
    const screenplay = await db.v2SElements.where('projectId').equals(projectId).toArray()
    return screenplay
}

export const getCharacters=async(projectId:string)=>{
    const character=await db.characters
    .where('projectId')
    .equals(projectId)
    .toArray()
    return character
}
